export const carMapping: { [key: string]: string } = {
  'CAR APRT': 'CAR_APRT',
  'CAR ATP': 'MVW_CAR',
  'SIGEF': 'SIGEF_INCRA',
  'APRT': 'SIMLAMGEO_APRT'
}

export const formatCar = (car: string) => {
  return carMapping[car];
}

export const formatCarList = (carList: string[]) => {
  return carList.map((car: any) => {
    return carMapping[car];
  });
}
